import React from "react"

interface SelectTipoProps {
  tipoDiscagem: string
  setTipoDiscagem: React.Dispatch<React.SetStateAction<string>>
  handleButton(): void
  width?: string
  height?: string
  nameButton?: string;
  isCaixa?: boolean;
}

export const SelectTipo = ({ tipoDiscagem, setTipoDiscagem, handleButton, width, height, nameButton, isCaixa }: SelectTipoProps) => {
  return (
    <div className={`rounded-xl bg-white flex items-center justify-between flex-col p-4  ${width && height ? `w-[${width}] h-[${height}] ` : 'w-[30%] h-[30%] shadow-lg'}`}>
      <h3 className="w-full text-center text-xl text-primary font-semibold mb-8">Escolha o estilo de discagem:</h3>



      <select value={tipoDiscagem} onChange={(e) => setTipoDiscagem(e.target.value)} className="m-2 w-full rounded-sm bg-gray-200 p-2 text-lg text-gray-600 outline-none">
        <option value="Manual">Manual</option>
        {!isCaixa && <option value="Automática">Automática</option>}

      </select>

      <button onClick={() => handleButton()} className="p-2 bg-primary text-center rounded-xl text-white font-semibold m-2  w-full">{nameButton ? nameButton : "Abrir Operador Caixa"}</button>
    </div>
  )
}